import { render, staticRenderFns } from "./display-attribute-selector.vue?vue&type=template&id=24378f35&"
import script from "./display-attribute-selector.vue?vue&type=script&lang=js&"
export * from "./display-attribute-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports